import { useAppSelector } from "../../../app/store";
import UserSupportTickets from "../../../components/SupportTickets/UserSupportTickets";
import CustomEmpty from "../../../components/ui/CustomEmpty";
import Loader from "../../../components/ui/Loader";
import { useGetEmployeeDetailsQuery } from "../../../features/employee/employeeApi";
import useError from "../../../hooks/useError";
import SidebarLayout from "../../../layouts/SidebarLayout";

export default function MySupportTickets() {
  const { authInfo } = useAppSelector((state) => state.auth);
  const { data, isLoading, isError, error } = useGetEmployeeDetailsQuery(
    String(authInfo?.id || ""),
    { skip: !authInfo?.id }
  );

  useError(isError, error, "Get employee profile fail");

  const memberId = data?.data?.employee?.member_id;

  return (
    <SidebarLayout title="Support Tickets">
      <div className="bg-white rounded-md p-4">
        {isLoading ? (
          <Loader />
        ) : memberId ? (
          <UserSupportTickets memberId={memberId} />
        ) : (
          <CustomEmpty description="Employee profile not found" />
        )}
      </div>
    </SidebarLayout>
  );
}
